// @ts-ignore
export default function addEventListener(type, listener, options?) {
  if (window && 'addEventListener' in window) {
    window.addEventListener(type, listener, options);
  }
}
